import Home from "../pages/home";
import Login from "../pages/auth/Login";
import Router from "./Router";

// Farm Management
import Farms from "../pages/farmManagement/farms";

// Dashboard component
const Dashboard = () => (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-6">Dashboard</h1>
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
      <p>Welcome to your dashboard! This is a protected route.</p>
    </div>
  </div>
);

// Profile component
const Profile = () => (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-6">User Profile</h1>
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
      <p>
        This is your profile page. It's protected and only accessible when
        logged in.
      </p>
    </div>
  </div>
);

// NotFound component
const NotFound = () => (
  <div className="container mx-auto px-4 py-8 text-center">
    <h1 className="text-4xl font-bold mb-4">404</h1>
    <p className="text-xl mb-6">Page Not Found</p>
    <p>The page you are looking for doesn't exist or has been moved.</p>
  </div>
);

// Add this type definition at the top of your file
type RouteConfig = {
  path: string;
  element: React.ReactNode;
  protected: boolean;
};

// Then update your routes object type
const routes: Record<string, RouteConfig> = {
  home: {
    path: "/",
    element: <Home />,
    protected: false,
  },
  login: {
    path: "/auth/login",
    element: <Login />,
    protected: false,
  },
  dashboard: {
    path: "/dashboard",
    element: <Dashboard />,
    protected: true,
  },
  profile: {
    path: "/profile",
    element: <Profile />,
    protected: true,
  },
  farmManagement: {
    path: "/farm-management/farms",
    element: <Farms />,
    protected: false,
  },
  notFound: {
    path: "*",
    element: <NotFound />,
    protected: false,
  },
};

// Export the routes object for use in Router.tsx
export { routes };

// Export a RouterComponent that uses the routes
export default function RouterComponent() {
  return <Router />;
}
